export const LEVELUP_ACTIONS = {
  OPEN_ROLE_SELECTION_MODAL: 'OPEN_ROLE_SELECTION_MODAL',
  CLOSE_ROLE_SELECTION_MODAL: 'CLOSE_ROLE_SELECTION_MODAL',
  SET_LEVEL_UP_DETAILS: 'SET_LEVEL_UP_DETAILS',
  SET_IS_MANAGER_FLAG: 'SET_IS_MANAGER_FLAG',
  UPDATE_COMPETENCY_TARGET_DATE: 'UPDATE_COMPETENCY_TARGET_DATE',
  UPDATE_COMPETENCY_PROGRESS_STATUS: 'UPDATE_COMPETENCY_PROGRESS_STATUS',
  SET_ONE_ON_ONE_INSTANCE_DETAILS: 'SET_ONE_ON_ONE_INSTANCE_DETAILS',
  SET_SELECTED_ROLE: 'SET_SELECTED_ROLE',
  SET_ROLE_OPTIONS: 'SET_ROLE_OPTIONS',
};
